<template>
    <div class="calendar-title flex">
        <vs-button class="text-center schedule-calendar-btn" type="filled" icon-pack="feather" icon="icon-arrow-left" @click.prevent="selectPrevious">
          <span v-text="$t(prevMonth)" />
        </vs-button>
        <div class="calendar-month-title flex-row">
            <h4 v-if="currentLanguage === 'kr'" class="text-center" v-text="`${$t(selectedMonth)} ${selectedMonth}`" />
            <h4 v-else class="text-center" v-text="`${$t(selectedMonth)}`" />
        </div>
        <vs-button class="text-center schedule-calendar-btn" type="filled" icon-pack="feather" icon="icon-arrow-right" @click.prevent="selectNext">
          <span v-text="$t(nextMonth)" />
        </vs-button>
    </div>

</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'CalendarModeSelector',
  props: {
    currentDate: {
      type: String,
      required: true
    },
    selectedDate: {
      type: Object,
      required: true
    }
  },
  computed: {
    selectedMonth () {
      return this.selectedDate.format('MMMM')
    },
    selectedYear () {
      return this.selectedDate.format('YYYY')
    },
    prevMonth () {
      return dayjs(this.selectedDate).subtract(1, 'month').format('MMMM')
    },
    nextMonth () {
      return dayjs(this.selectedDate).add(1, 'month').format('MMMM')
    },
    currentLanguage () {
      return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
    }
  },
  methods: {
    selectPrevious () {
      const newSelectedDate = dayjs(this.selectedDate).subtract(1, 'month')
      this.$emit('dateSelected', newSelectedDate)
    },

    selectCurrent () {
      const newSelectedDate = dayjs(this.currentDate)
      this.$emit('dateSelected', newSelectedDate)
    },
    selectNext () {
      const newSelectedDate = dayjs(this.selectedDate).add(1, 'month')
      this.$emit('dateSelected', newSelectedDate)
    }
  }
}
</script>

<style >
</style>
